export const socialsData = {
    github: 'https://github.com/CandyVelazco100',
    facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/candy-velazco',
    instagram: 'https://www.instagram.com/',
    codepen: 'https://codepen.io/',
    behance: 'https://www.behance.net/nohemivelazcom',
    Dribble: 'https://dribbble.com/CandyVelaM',
    twitter: 'https://twitter.com/',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/',
    kaggle: 'https://www.kaggle.com/nohemivelazco'
}